<template>
  <div>
    <AGCLabel required v-if="label">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">{{ subLabel }}</slot>
      </template>
    </AGCLabel>
    <div v-if="isShowSelect">
      <b-form-select
        v-model="selectedOption"
        :options="[{ value: '', text: '範本' }, ...options]"
        class="mb-2"
        style="width: 10rem;"
      ></b-form-select>
    </div>
    <ContentEditor
      v-model="inputVal"
      required
      name="公司簡介"
      class="mb-3"
      :toolbar="toolbarValue"
      rules="required|maxWord:500"
      :read-only="disabled"
    >
    </ContentEditor>
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import agcFormElementMixin from '@/mixins/agc-form-element';
import http from '@/helpers/http';
import { map } from 'rxjs/operators';

export default {
  name: 'CompanyIntroTemplateContentEditor',
  mixins: [agcFormElementMixin],
  components: {
    AGCLabel,
    BFormSelect,
    ContentEditor,
  },
  props: {
    isShowSelect: {
      type: Boolean,
    },
  },
  data: () => ({
    selectedOption: '',
    toolbarValue: [
      `
      undo redo |
      bold italic underline |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent |
      link |
    `,
    ],
  }),
  subscriptions() {
    return {
      options: http({
        method: 'GET',
        url: '/agc-public-api/companyintrotemplates',
      }).pipe(
        map(({ result }) => result.map(({ title, content }) => ({ value: content, text: title }))),
      ),
    };
  },
  watch: {
    selectedOption() {
      this.inputVal = this.selectedOption;
    },
  },
};
</script>

<style></style>
